import style from './what-is-dedicated-team.module.scss';
import template from '@components/services/services.module.scss';
import Image from 'next/image';

interface IWhatIsDedicatedTeamSection {
  imageSrc: string;
  title: string;
  paragraphs: IWhatIsDedicatedTeamParagraphs[];
}

interface IWhatIsDedicatedTeamParagraphs {
  title: string;
  text: string;
}

const WhatIsDedicatedTeamSection = ({ imageSrc, title, paragraphs }: IWhatIsDedicatedTeamSection) => {
  return (
    <section className={`${template.section} ${template.section_light} ${style.section}`}>
      <div
        className={`${template.container} ${template.container_large} ${style.block} ${template.flex} ${template.flex_justify_content_space_between}`}
      >
        <div className={`${style.textblock}`}>
          <div className={`${template.title} ${template.title_large} ${template.text_align_l} ${template.mb20}`}>
            <h2 className={`${template.title_large}`}>{title}</h2>
          </div>
          <div className={`${style.textblock__content}`}>
            {paragraphs.map((paragraph: IWhatIsDedicatedTeamParagraphs, index: number) => {
              return (
                <>
                  {paragraph.title ? (
                    <div className={`${template.text} ${template.title_small} ${template.mb20}`}>{paragraph.title}</div>
                  ) : null}
                  <div
                    key={index}
                    className={`${template.text} ${template.text_small} ${template.text_color_main} ${template.text_align_l} ${style.textblock__content__text} ${template.mb16} ${template.fw400}`}
                    dangerouslySetInnerHTML={{ __html: paragraph.text }}
                  ></div>
                </>
              );
            })}
          </div>
        </div>
        <div className={`${template.image} ${template.image_medium} ${style.image}`}>
          <Image src={imageSrc} alt={title} layout={'fill'} />
        </div>
      </div>
    </section>
  );
};

export default WhatIsDedicatedTeamSection;
